import * as React from 'react';
import { SVGProps } from 'react';

export const Box = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M16 1.9375L1.9375 7.5625L16 13.1875L30.0625 7.5625L16 1.9375Z"
      stroke="#071114"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1.9375 7.5625V24.4375L16 30.0625V13.1875L1.9375 7.5625Z"
      stroke="#071114"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M30.0625 7.5625V24.4375L16 30.0625V13.1875L30.0625 7.5625Z"
      stroke="#071114"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M23.7339 10.0938L9.67139 4.46875"
      stroke="#071114"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M26.7812 21.625L24.4375 22.5625"
      stroke="#071114"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default Box;
